import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { red } from '@mui/material/colors';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
}

export const ConfirmDeleteDialog = ({ open, onClose }: ConfirmDeleteDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Comment</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this comment?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => onClose(false)}
          color="primary"
          sx={{
            color: 'var(--gentian-black)',
            borderColor: 'var(--gentian-black)',
            '&:hover': {
              backgroundColor: 'var(--sundrop-yellow)',
              borderColor: 'var(--gentian-black)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onClose(true)}
          color="error"
          autoFocus
          sx={{
            backgroundColor: red[500],
            color: 'var(--gentian-white)',
            '&:hover': {
              backgroundColor: red[700],
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
